var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MemberCard',{attrs:{"expand":true,"Member":_vm.Member}})}
var staticRenderFns = []

export { render, staticRenderFns }